/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Draft_BannerInputs */

const en_directory_submit_enrich_draft_banner = /** @type {(inputs: Directory_Submit_Enrich_Draft_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft saved.`)
};

const zh_directory_submit_enrich_draft_banner = /** @type {(inputs: Directory_Submit_Enrich_Draft_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿已保存。`)
};

/**
* | output |
* | --- |
* | "Draft saved." |
*
* @param {Directory_Submit_Enrich_Draft_BannerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_draft_banner = /** @type {((inputs?: Directory_Submit_Enrich_Draft_BannerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Draft_BannerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_draft_banner(inputs)
	return zh_directory_submit_enrich_draft_banner(inputs)
});
export { directory_submit_enrich_draft_banner as "directory.submit.enrich.draft_banner" }